import React, { useEffect, useState } from 'react';
import Hero1 from '../../assets/Hero1.png'
import Hero2 from '../../assets/Hero2.svg'
import Hero3 from '../../assets/Hero3.svg'

const images = [
  Hero1,
  Hero2,
  Hero3,
];

const SUBSCRIBE_URL = process.env.REACT_APP_SUBSCRIBE_URL;

export default function ImageSlideshow() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false); // Start fading out
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        setFade(true); // Fade in new image
      }, 500); // Match fade-out duration
    }, 4000); // Every 4 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative w-[85%] h-[40rem] overflow-hidden  rounded-b-[2rem] mx-auto hidden md:block ">
      {images.map((img, index) => (
        <img
          key={index}
          src={img}
          alt={`slide-${index}`}
          className={`
            absolute inset-0 w-full h-full object-cover object-top transition-opacity duration-[1500ms] ease-linear
            ${index === currentIndex ? (fade ? 'opacity-100' : 'opacity-0') : 'opacity-0'}
          `}
        />
      ))}
      <div className="absolute top-20 left-10 z-10 flex flex-col  text-white max-w-md space-y-4  p-5 h-[30rem] ">
        <h1 className="text-5xl uppercase leading-tight font-extrabold">Welcome to Phamtrix</h1>
        <p className="text-lg  ">
          Pharmtrix is a Pharmacy Inventory and Prescription management system that lets you stake control of your pharmacy operations. Our solution is scalable and streamlines the functionality of your workflow, improving each segment along the way, including inventory management, inventory replenishment, stock management, sale transactions and more.
        </p>
        <div className='mt-5'>
          <button className=" bg-blue-500 mt-5 rounded-full text-white px-6 py-3  shadow-md transition" onClick={() => {window.open(SUBSCRIBE_URL,'_blank')}}>
            Subscribe
          </button>
        </div>

      </div>

    </div>
  );
}
